import React, { ChangeEvent, FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { clone, pull, uniq } from 'lodash';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';

import { NotificationDeliveryType, UserProfileInput } from 'api';
import { ValidatedSwitch } from 'components';

const useStyles = makeStyles(theme => ({
  labelPlacementStart: {
    marginTop: -theme.spacing(1),
    marginLeft: 0,
  },
}));

const Notifications: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<UserProfileInput>();

  const { notification_delivery_types } = values;

  function checkedFn(deliveryType: NotificationDeliveryType) {
    return notification_delivery_types && notification_delivery_types.includes(deliveryType);
  }

  function handleChange(event: ChangeEvent<HTMLInputElement>, value: boolean) {
    const deliveryType = event.target.name as NotificationDeliveryType;
    const deliveryTypes = clone(notification_delivery_types);

    if (value) {
      deliveryTypes.splice(0, 0, deliveryType);
    } else {
      pull(deliveryTypes, deliveryType);
    }

    setFieldValue('notification_delivery_types', uniq(deliveryTypes));
  }

  function renderPushLabel() {
    return <Fragment>{t('user:pushNotifications')}</Fragment>;
  }

  function renderEmailLabel() {
    return <Fragment>{t('user:emailNotifications')}</Fragment>;
  }

  return (
    <Fragment>
      <Grid container>
        <Grid item xs={3}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <NotificationsIcon color="action" />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2">{t('common:notification_plural')}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs>
          <Grid container spacing={5}>
            <Grid item>
              <ValidatedSwitch
                name="push"
                color="primary"
                label={renderPushLabel()}
                labelClasses={{ labelPlacementStart: classes.labelPlacementStart }}
                onChange={handleChange}
                checkedFn={() => checkedFn(NotificationDeliveryType.Push)}
              />
            </Grid>
            <Grid item>
              <ValidatedSwitch
                name="email"
                color="primary"
                label={renderEmailLabel()}
                labelClasses={{ labelPlacementStart: classes.labelPlacementStart }}
                onChange={handleChange}
                checkedFn={() => checkedFn(NotificationDeliveryType.Email)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Notifications;
